var _path, _g, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGalleryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_692_11704",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00037 2H21.96V21.9498H2.00037V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_692_11704)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65037 3.5C5.12937 3.5 3.50037 5.227 3.50037 7.899V16.051C3.50037 18.724 5.12937 20.45 7.65037 20.45H16.3004C18.8274 20.45 20.4604 18.724 20.4604 16.051V7.899C20.4604 5.227 18.8274 3.5 16.3004 3.5H7.65037ZM16.3004 21.95H7.65037C4.27037 21.95 2.00037 19.579 2.00037 16.051V7.899C2.00037 4.371 4.27037 2 7.65037 2H16.3004C19.6854 2 21.9604 4.371 21.9604 7.899V16.051C21.9604 19.579 19.6854 21.95 16.3004 21.95Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28138 17.1809C5.09538 17.1809 4.91038 17.1129 4.76538 16.9749C4.46438 16.6909 4.45238 16.2149 4.73738 15.9159L6.26538 14.3029C7.07438 13.4439 8.43938 13.4019 9.30238 14.2119L10.2604 15.1839C10.5274 15.4539 10.9614 15.4589 11.2294 15.1949C11.3304 15.0759 13.5084 12.4309 13.5084 12.4309C13.9224 11.9289 14.5064 11.6189 15.1554 11.5549C15.8054 11.4979 16.4364 11.6869 16.9394 12.0999C16.9824 12.1349 17.0214 12.1689 19.2174 14.4239C19.5064 14.7199 19.5014 15.1949 19.2044 15.4839C18.9084 15.7749 18.4324 15.7659 18.1434 15.4699C18.1434 15.4699 16.0944 13.3669 15.9484 13.2249C15.7934 13.0979 15.5444 13.0239 15.2994 13.0479C15.0504 13.0729 14.8264 13.1919 14.6674 13.3849C12.3434 16.2039 12.3154 16.2309 12.2774 16.2679C11.4194 17.1099 10.0344 17.0959 9.19138 16.2359C9.19138 16.2359 8.26138 15.2919 8.24538 15.2729C8.01438 15.0589 7.60238 15.0729 7.35538 15.3339L5.82538 16.9469C5.67738 17.1029 5.47938 17.1809 5.28138 17.1809Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55757 8.12891C8.00457 8.12891 7.55457 8.57891 7.55457 9.13291C7.55457 9.68691 8.00457 10.1379 8.55857 10.1379C9.11257 10.1379 9.56357 9.68691 9.56357 9.13291C9.56357 8.57991 9.11257 8.12991 8.55757 8.12891ZM8.55857 11.6379C7.17757 11.6379 6.05457 10.5139 6.05457 9.13291C6.05457 7.75191 7.17757 6.62891 8.55857 6.62891C9.94057 6.62991 11.0636 7.75391 11.0636 9.13291C11.0636 10.5139 9.93957 11.6379 8.55857 11.6379Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryIcon);
export default __webpack_public_path__ + "static/media/galleryIcon.6dd5ebed5c998f1b3ea298013e5dfb15.svg";
export { ForwardRef as ReactComponent };